import React, { useState, useEffect } from 'react';
import { Send } from 'lucide-react';

const FloatingCTA = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 400);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div
      className={`fixed bottom-6 right-6 z-50 transition-all duration-300 transform ${
        isVisible ? 'translate-y-0 opacity-100' : 'translate-y-20 opacity-0'
      }`}
    >
      <a
        href="https://t.me/RealFtcAdmin"
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center gap-3 bg-[#F8F8F8] shadow-lg rounded-full pl-4 pr-2 py-2 hover:shadow-xl transition-all duration-300 group border border-gray-200"
      >
        <span className="text-[#191919] font-medium text-sm">
          Contact Support
        </span>
        <div className="w-10 h-10 bg-[#33CCCC] rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
          <Send className="w-5 h-5 text-[#191919]" />
        </div>
      </a>
    </div>
  );
};

export default FloatingCTA;
